export interface OrderStatusOption {
  value: string;
  label: string;
  colorClass: string;
}

export const ORDER_STATUS_OPTIONS: readonly OrderStatusOption[] = [
  { value: 'waitingForApproval', label: 'Waiting for approval', colorClass: 'bg-waitingForApproval' },
  { value: 'processing',         label: 'Processing',           colorClass: 'bg-processing' },
  { value: 'done',               label: 'Done',                 colorClass: 'bg-done' },
  { value: 'collected',          label: 'Collected',            colorClass: 'bg-collected' },
  { value: 'rejected',           label: 'Rejected',             colorClass: 'bg-rejected' },
];

// Statuses that trigger permanent photo deletion (handled server-side) and therefore
// require explicit user confirmation before being saved.
export const DESTRUCTIVE_STATUSES = ['done', 'collected', 'rejected'] as const;

export const isDestructiveStatus = (value: string): boolean =>
  DESTRUCTIVE_STATUSES.includes(value as (typeof DESTRUCTIVE_STATUSES)[number]);

// Statuses of orders that have been printed; used for statistics.
export const PRINTED_STATUSES = ['done', 'collected'] as const;

export const getOrderStatusOption = (value: string): OrderStatusOption | undefined =>
  ORDER_STATUS_OPTIONS.find(o => o.value === value);
